import { useTranslation } from 'react-i18next';
import { useToggleState } from '@anytag/shared-hooks';
import {
  AnalyticsComparableAccounts,
  AnalyticsComparableAccountsProps,
  AddAnalyticsComparableAccountModal,
  DeleteAnalyticsComparableAccountModal
} from '../../shared';
import { AnalyticsYoutubeComparableAccountType } from '../types';
import { useCreateDeleteYoutubeComparableAccount } from './hooks';

export type AnalyticsCompareYoutubeAccountsProps = Pick<
  AnalyticsComparableAccountsProps<AnalyticsYoutubeComparableAccountType>,
  'accounts' | 'maxAccounts' | 'mainAccountId' | 'hiddenAccountIds' | 'onSelectAccount' | 'hasFreePlan'
>;

export const AnalyticsCompareYoutubeAccounts = ({
  mainAccountId,
  ...restProps
}: AnalyticsCompareYoutubeAccountsProps) => {
  const { t } = useTranslation();
  const addModal = useToggleState();
  const {
    adding,
    deleting,
    deletingAccount,
    setDeletingAccount,
    resetDeletingAccount,
    handleAddNewComparableAccount,
    handleDeleteComparableAccount
  } = useCreateDeleteYoutubeComparableAccount({ mainAccountId });

  return (
    <>
      <AnalyticsComparableAccounts
        {...restProps}
        mainAccountId={mainAccountId}
        onAddNewAccount={addModal.open}
        onDeleteAccount={setDeletingAccount}
      />

      <AddAnalyticsComparableAccountModal
        loading={adding}
        open={addModal.status}
        onClose={addModal.close}
        onSubmit={(accountName) => handleAddNewComparableAccount(accountName, addModal.close)}
        title={t('Dialog.Add Channel To Compare')}
        description={t('Dialog.Please enter YouTube channel URL that you wish to compare to')}
        customInput={{ title: t('TextForm.YouTube'), placeholder: t<string>('YouTube channel URL') }}
      />

      <DeleteAnalyticsComparableAccountModal
        loading={deleting}
        onClose={resetDeletingAccount}
        deletingAccount={deletingAccount}
        onSubmit={handleDeleteComparableAccount}
        title={t('Dialog.Delete comparable Channel')}
      />
    </>
  );
};
